module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    ref: "figure"
  }, [(_vm.figureHeight > 0 && _vm.figureWidth > 0) ? _c('svg', {
    attrs: {
      "viewBox": ("0 0 " + _vm.figureWidth + " " + _vm.figureHeight)
    }
  }, [(_vm.markers) ? _c('SizeArrow', {
    staticClass: "label",
    attrs: {
      "from": {
        x: _vm.horizontalPadding,
        y: _vm.verticalPadding
      },
      "to": {
        x: _vm.width - _vm.horizontalPadding,
        y: _vm.verticalPadding
      },
      "spacing": 20,
      "spacingDirection": 'top',
      "color": "orange",
      "value": _vm.caddy.width
    },
    on: {
      "input": function (e) { return (_vm.caddy.width = e); }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.markers) ? _c('SizeArrow', {
    staticClass: "label",
    attrs: {
      "from": {
        x: _vm.horizontalPadding,
        y: _vm.verticalPadding
      },
      "to": {
        x: _vm.horizontalPadding,
        y: _vm.height - _vm.verticalPadding
      },
      "spacing": 80,
      "spacingDirection": 'left',
      "color": "orange",
      "value": _vm.caddy.height
    },
    on: {
      "input": function (e) { return (_vm.caddy.height = e); }
    }
  }) : _vm._e(), _vm._v(" "), _c('rect', {
    attrs: {
      "x": _vm.horizontalPadding,
      "y": _vm.verticalPadding,
      "width": _vm.width - _vm.horizontalPadding * 2,
      "height": _vm.height - _vm.verticalPadding * 2,
      "stroke": "orange",
      "fill": "orange"
    }
  }), _vm._v(" "), (_vm.markers) ? _c('SizeArrow', {
    staticClass: "label",
    attrs: {
      "from": {
        x: _vm.horizontalPadding + _vm.innerX,
        y: _vm.height - _vm.verticalPadding - _vm.innerY - _vm.innerHeight
      },
      "to": {
        x: _vm.horizontalPadding + _vm.innerX,
        y: _vm.height - _vm.verticalPadding - _vm.innerY
      },
      "spacing": 20 + _vm.innerX,
      "spacingDirection": 'left',
      "color": "green",
      "value": _vm.caddy.contentHeight
    },
    on: {
      "input": function (e) { return (_vm.caddy.contentHeight = e); }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.markers) ? _c('SizeArrow', {
    staticClass: "label",
    attrs: {
      "from": {
        x: _vm.horizontalPadding + _vm.innerX,
        y: _vm.height - _vm.innerY - _vm.verticalPadding
      },
      "to": {
        x: _vm.horizontalPadding + _vm.innerX,
        y: _vm.height - _vm.verticalPadding
      },
      "spacing": 20 + _vm.innerX,
      "spacingDirection": 'left',
      "color": "green",
      "value": _vm.caddy.contentY
    },
    on: {
      "input": function (e) { return (_vm.caddy.contentY = e); }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.markers) ? _c('SizeArrow', {
    staticClass: "label",
    attrs: {
      "from": {
        x: _vm.horizontalPadding + _vm.innerX,
        y: _vm.verticalPadding
      },
      "to": {
        x: _vm.horizontalPadding + _vm.innerX,
        y: _vm.height - _vm.innerHeight - _vm.innerY - _vm.verticalPadding
      },
      "spacing": 20 + _vm.innerX,
      "spacingDirection": 'left',
      "color": "green",
      "disabled": "",
      "value": _vm.caddy.height - _vm.caddy.contentY - _vm.caddy.contentHeight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.markers) ? _c('SizeArrow', {
    staticClass: "label",
    attrs: {
      "from": {
        x: _vm.horizontalPadding + _vm.innerX,
        y: _vm.height - _vm.verticalPadding - _vm.innerY
      },
      "to": {
        x: _vm.horizontalPadding + _vm.innerX + _vm.innerWidth,
        y: _vm.height - _vm.verticalPadding - _vm.innerY
      },
      "spacing": 20 + _vm.innerY,
      "spacingDirection": 'bottom',
      "color": "green",
      "value": _vm.caddy.contentWidth
    },
    on: {
      "input": function (e) { return (_vm.caddy.contentWidth = e); }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.markers) ? _c('SizeArrow', {
    staticClass: "label",
    attrs: {
      "from": {
        x: _vm.horizontalPadding,
        y: _vm.height - _vm.verticalPadding - _vm.innerY
      },
      "to": {
        x: _vm.horizontalPadding + _vm.innerX,
        y: _vm.height - _vm.verticalPadding - _vm.innerY
      },
      "spacing": 20 + _vm.innerY,
      "spacingDirection": 'bottom',
      "color": "green",
      "value": _vm.caddy.contentX
    },
    on: {
      "input": function (e) { return (_vm.caddy.contentX = e); }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.markers) ? _c('SizeArrow', {
    staticClass: "label",
    attrs: {
      "from": {
        x: _vm.horizontalPadding + _vm.innerX + _vm.innerWidth,
        y: _vm.height - _vm.verticalPadding - _vm.innerY
      },
      "to": {
        x: _vm.width - _vm.horizontalPadding,
        y: _vm.height - _vm.verticalPadding - _vm.innerY
      },
      "spacing": 20 + _vm.innerY,
      "spacingDirection": 'bottom',
      "color": "green",
      "disabled": "",
      "value": _vm.caddy.width - _vm.caddy.contentX - _vm.caddy.contentWidth
    }
  }) : _vm._e(), _vm._v(" "), _c('rect', {
    attrs: {
      "x": _vm.horizontalPadding + _vm.innerX,
      "y": _vm.height - _vm.innerY - _vm.verticalPadding - _vm.innerHeight,
      "width": _vm.innerWidth,
      "height": _vm.innerHeight,
      "stroke": "green",
      "fill": "green"
    }
  }), _vm._v(" "), (_vm.markers) ? _c('SizeArrow', {
    staticClass: "label",
    attrs: {
      "from": {
        x: _vm.width - _vm.horizontalPadding,
        y: _vm.height - _vm.ticketStripHeight - _vm.verticalPadding
      },
      "to": {
        x: _vm.width - _vm.horizontalPadding,
        y: _vm.height - _vm.verticalPadding
      },
      "spacing": 20,
      "color": "blue",
      "spacingDirection": 'right',
      "value": _vm.caddy.coverHeight
    },
    on: {
      "input": function (e) { return (_vm.caddy.coverHeight = e); }
    }
  }) : _vm._e(), _vm._v(" "), _c('rect', {
    attrs: {
      "x": _vm.horizontalPadding,
      "y": _vm.height - _vm.ticketStripHeight - _vm.verticalPadding,
      "width": _vm.width - _vm.horizontalPadding * 2,
      "height": _vm.ticketStripHeight,
      "stroke": "blue",
      "fill": "blue"
    }
  }), _vm._v(" "), (_vm.markers) ? _c('SizeArrow', {
    staticClass: "label fascia",
    attrs: {
      "from": {
        x: _vm.width - _vm.horizontalPadding,
        y: _vm.verticalPadding
      },
      "to": {
        x: _vm.width - _vm.horizontalPadding,
        y: _vm.height - _vm.ticketStripHeight - _vm.verticalPadding
      },
      "spacing": 20,
      "disabled": "",
      "value": _vm.caddy.height - _vm.caddy.coverHeight,
      "spacingDirection": 'right'
    }
  }) : _vm._e(), _vm._v(" "), _c('rect', {
    attrs: {
      "x": _vm.horizontalPadding,
      "y": _vm.verticalPadding,
      "width": _vm.width - _vm.horizontalPadding * 2,
      "height": _vm.height - _vm.verticalPadding * 2 - _vm.ticketStripHeight,
      "stroke": "red",
      "fill": "red"
    }
  }), _vm._v(" "), _vm._l((_vm.caddy.clipDevices), function(anchor, i) {
    return _c('Point', {
      key: i,
      attrs: {
        "x": _vm.horizontalPadding + anchor.x * _vm.widthRatio,
        "y": _vm.height - _vm.verticalPadding - anchor.y * _vm.heightRatio,
        "value": anchor,
        "markers": _vm.markers,
        "canDelete": _vm.caddy.clipDevices.length > 1
      },
      on: {
        "delete": function($event) {
          _vm.caddy.clipDevices = _vm.caddy.clipDevices.filter(function (e) { return e !== anchor; });
        },
        "input": function (v) {
          anchor.x = v.x;
          anchor.y = v.y;
        }
      }
    })
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8df2d71e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/caddy-preview.vue
// module id = 3309
// module chunks = 0